// eslint-disable-next-line no-var
export var FullScreenController = (window.FullScreenController = (function () {
   let doc = document;
   let docElement = doc.documentElement;
   let iconSelector = '.js-fullscreen > i';

   function isFullScreen() {
      return doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement;
   }

   function openFullscreen(checkSupport) {
      if (docElement.requestFullscreen) {
         checkSupport || docElement.requestFullscreen();
         /**
 * According to http://caniuse.com/#feat=fullscreen IE11 doesn't really support
 * fullscreening an iframe :-(
      } else if (docElement.msRequestFullscreen) {
         checkSupport || docElement.msRequestFullscreen();
*/
      } else if (docElement.mozRequestFullScreen) {
         checkSupport || docElement.mozRequestFullScreen();
      } else if (docElement.webkitRequestFullscreen) {
         checkSupport || docElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else {
         return false;
      }

      if (!checkSupport) {
         $(iconSelector).removeClass('fa-expand').addClass('fa-compress');
      }
      return true;
   }

   function closeFullscreen() {
      if (doc.exitFullscreen) {
         doc.exitFullscreen();
      } else if (doc.msExitFullscreen) {
         doc.msExitFullscreen();
      } else if (doc.mozCancelFullScreen) {
         doc.mozCancelFullScreen();
      } else if (doc.webkitExitFullscreen) {
         doc.webkitExitFullscreen();
      }

      $(iconSelector).removeClass('fa-compress').addClass('fa-expand');
   }

   function toggleFullScreen() {
      if (isFullScreen()) {
         closeFullscreen();
      } else {
         openFullscreen();
      }
   }

   return {
      toggle: toggleFullScreen,

      toggleParentFullscreen: function () {
         doc = window.parent.document;
         docElement = doc.documentElement;
         iconSelector = '.js-operator-fullscreen > i';
         toggleFullScreen();
      },

      supported: function () {
         return openFullscreen(/* check support */ true);
      },
   };
})());
